export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { label: '首页', href: '#hero' },
    { label: '热搜榜单', href: '#ranking' },
    { label: '热门帖子', href: '#cards' },
    { label: '话题广场', href: '#topics' },
    { label: '最新快讯', href: '#updates' },
    { label: '投稿爆料', href: '#contact' },
    { label: '关于我们', href: '#about' },
    { label: '常见问题', href: '#faq' },
  ];

  return (
    <footer id="footer" className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          {/* Top row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            {/* Brand */}
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-line text-white text-lg"></i>
                </div>
                <span className="text-lg font-heading font-bold text-background-50">
                  吃瓜黑料爆料
                </span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed">
                全网瓜友的吃瓜交流社区。汇聚娱乐八卦小道消息、黑料爆料贴吧网友分享，热评不断，来这里吃最新鲜的瓜。
              </p>
            </div>

            {/* Quick links */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2">
                {quickLinks.slice(0, 4).map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">更多链接</h4>
              <ul className="space-y-2">
                {quickLinks.slice(4).map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Partners */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-400 leading-relaxed">
                本社区为独立运营的吃瓜交流平台，欢迎优质内容创作者与媒体伙伴联系合作。
              </p>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-background-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 吃瓜黑料爆料 - 吃瓜论坛与八卦讨论区。仅供娱乐交流，内容不代表本站立场。
            </p>
            <div className="flex items-center gap-4 text-xs text-background-400">
              <a
                href="#faq"
                onClick={(e) => handleNavClick(e, '#faq')}
                className="hover:text-primary-400 transition-colors cursor-pointer"
              >
                常见问题
              </a>
              <a
                href="#contact"
                onClick={(e) => handleNavClick(e, '#contact')}
                className="hover:text-primary-400 transition-colors cursor-pointer"
              >
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}